import api from "../../services/api";
import { toast } from "react-toastify";
import getCommercial from "../../util/getCommercial";
import { calculateFees, nextBusinessDayBR } from "@entaoformouorg/formou-shared-functions";
import { stringToDate } from "../../hooks/utils/useFormat";

export async function listFinancial(props) {
  const { config, me, query } = props;
  const _url_prefix = me?.type === "Formando" ? "trainee/" : "";

  try {
    const { data: _payments } = await api.get(`${_url_prefix}paymentslips?${query}`, config);
    const _payments_return = !!_payments?.data
      ? {
          ..._payments,
          data: formatPaymentSlips(_payments?.data),
        }
      : formatPaymentSlips(_payments);
    return _payments_return;
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar o Financeiro.");
  }
  //Falta ver como vai ser a paginação aqui, roube do componente antigo
}

export async function traineeFinancial(props) {
  const { config, me, trainee_id, commercial_id } = props;
  try {
    const _commercial = await getCommercial(commercial_id);
    let _trainee = _commercial?.trainees?.find(__trainee => __trainee.id === trainee_id) || {};
    let { data: _custom_payments } = await api.get(`custom-payment?trainee_id=${trainee_id}&paginate=false`, config);
    _custom_payments = _custom_payments.map(__payment => ({
      ...__payment,
      cost: (__payment?.value || 0) * (__payment?.quantity || 0) + (__payment?.convenience_fee || 0),
    }));
    const _aditional_items = _custom_payments?.filter(__item => __item.payer_type === "item_adicional");
    const _charges = _custom_payments?.filter(__item => __item.payer_type === "formando");
    const { data: _discounts } = await api.get(`discount-trainee?trainee_id=${trainee_id}`, config);
    const { data: _contributions_benefits } = !_commercial?.aporte_retirada
      ? await api.get(`contributions-for-trainee-service/${trainee_id}/${commercial_id}`, config)
      : { parteProporcional: 0 };
    let { data: _slips } = await api.get(`/paymentslips/only-with-juros/${trainee_id}`, config);
    console.log("_slips", _slips);
    _slips = formatPaymentSlips(_slips);
    console.log("_slips Formated: ", _slips);
    _slips = {
      contracted: _slips.filter(__slip => __slip.payment_for === "Contratado") || [],
      charges: _slips.filter(__slip => __slip.payment_for === "Cobrança") || [],
      products: _slips.filter(__slip => __slip.payment_for === "Produto") || [],
    };

    const _events = [{ value: null, label: "-- Todos --" }].concat(
      _commercial?.packages_data?.events?.map(__event => ({
        value: __event.id,
        label: __event.name,
        resources: [{ value: null, label: "-- Todos --" }].concat(
          __event?.resources?.map(__resource => ({
            value: __resource.resource_id,
            label: __resource.name,
          })) || [],
        ),
      })) || [],
    );

    const _financial = {
      ..._trainee.packages_data,
      due_date: parseInt(_trainee?.due_date) || null,
      aditional_items: _aditional_items,
      discounts: _discounts,
      charges: _charges,
      payment_slips: _slips,
      values_calc: {
        contracted: {
          contracted_value:
            _trainee?.packages_data?.package?.cost_trainee +
            _trainee?.packages_data?.singles?.reduce((__acc, __single) => __acc + (__single?.cost_trainee || 0), 0) +
            _aditional_items?.reduce((__acc, __item) => __acc + (__item?.cost || 0), 0),
          discounts: _discounts?.reduce((__acc, __item) => __acc + (__item?.value || 0), 0),
          contributions_benefits: _contributions_benefits?.parteProporcional || 0,
          slips_taxes:
            _slips.contracted
              ?.filter(__slip => __slip.status !== "Cancelado")
              ?.reduce((__acc, __slip) => __acc + (__slip.tax || 0), 0) || 0,
          slips_discounts:
            _slips.contracted
              ?.filter(__slip => __slip.status !== "Cancelado")
              ?.reduce((__acc, __slip) => __acc + (__slip.discount || 0), 0) || 0,
          slips_fines_fees: _slips.contracted?.reduce((__acc, __slip) => __acc + (__slip.value_juros || 0), 0) || 0,
          payments_made:
            _slips.contracted
              ?.filter(__slip => __slip.status === "Pago")
              ?.reduce((__acc, __slip) => __acc + (__slip?.value_paid || 0), 0) || 0,
          payments_made_adjusts:
            _slips.contracted
              ?.filter(__slip => __slip.status === "Pago")
              ?.reduce((__acc, __slip) => __acc + (__slip?.discount || 0) - (__slip?.tax || 0), 0) || 0,
        },
      },
      commercial: {
        date_end: _commercial?.date_end,
        products: _commercial?.products,
        packages_data: {
          packages: _commercial?.packages_data?.packages,
          singles: _commercial?.packages_data?.singles,
          events: _events,
        },
      },
    };

    return _financial;
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar dados da Turma e Formando.");
  }
}

export async function traineeFinancialGroups(props) {
  const { commercial_id } = props;
  try {
    const _commercial = await getCommercial(commercial_id, null, "?contributions=true");

    let _groups = [];
    _commercial?.trainees?.forEach(__trainee => {
      let _options = {
        ...(__trainee.packages_data?.package?.id
          ? {
              value: `${__trainee.packages_data?.package?.id}`,
              label: __trainee.packages_data?.package?.name || ["-"],
            }
          : {
              value: "0",
              label: "Sem Pacote",
            }),
      };

      __trainee?.packages_data?.singles?.forEach(__single => {
        _options.value += `-${__single.id}`;
        _options.label += ` + ${__single.name}`;
      });

      let _existent_group = _groups.find(__group => __group.value === _options.value) || null;

      const _trainee_disabled_msg = !!__trainee.financial_released
        ? " (Financeiro Criado)"
        : !!__trainee.contributions_benefits
          ? " (Aportes Relacionados)"
          : __trainee.aditional_items?.length > 0
            ? " (Possui Itens Adicionais)"
            : __trainee.charges?.length > 0
              ? " (Possui Cobranças)"
              : __trainee.discounts?.length > 0
                ? " (Possui Descontos)"
                : false;

      const _trainee_option = {
        value: __trainee.id,
        label: `${__trainee.name}${_trainee_disabled_msg || ""}`,
        due_date: parseInt(__trainee?.due_date) || null,
        disabled: !!_trainee_disabled_msg,
      };
      if (!!_existent_group) {
        _existent_group.trainees.push(_trainee_option);
      } else {
        _groups.push({
          value: `${_options.value}`,
          label: `${_options.label}`,
          trainees: [_trainee_option],
          contracted_value:
            __trainee?.packages_data?.package?.cost_trainee +
              __trainee?.packages_data?.singles?.reduce(
                (__acc, __single) => __acc + (__single?.cost_trainee || 0),
                0,
              ) || 0,
          packages_data: {
            packages: __trainee.packages_data?.package,
            singles: __trainee.packages_data?.singles,
          },
        });
      }
    });
    _groups = _groups.map(__group => {
      const _can_negotiate = __group.trainees?.find(__trainee => !__trainee.disabled);

      return {
        ...__group,
        trainees: [{ value: "<SELECT_ALL>", label: "-- Marcar Todos --" }, ...__group.trainees],
        // disabled: false,
        disabled: !_can_negotiate,
      };
    });

    const _events = [{ value: null, label: "-- Todos --" }].concat(
      _commercial?.packages_data?.events?.map(__event => ({
        value: __event.id,
        label: __event.name,
        resources: [{ value: null, label: "-- Todos --" }].concat(
          __event?.resources?.map(__resource => ({
            value: __resource.id,
            label: __resource.name,
          })) || [],
        ),
      })) || [],
    );

    return {
      groups: _groups,
      commercial: {
        date_end: _commercial?.date_end,
        products: _commercial?.products,
        packages_data: {
          packages: _commercial?.packages_data?.packages,
          singles: _commercial?.packages_data?.singles,
          events: _events,
        },
      },
    };
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar os grupos da Turma.");
  }
}

export async function getMultiSlips(props) {
  const { config, me, slips } = props;
  try {
    let _slips = [];
    for await (const __slip_id of slips) {
      const { data: _slip } = await api.get(`paymentslips/${__slip_id}`, config);
      _slips.push(_slip);
    }
    _slips = formatPaymentSlips(_slips);
    return _slips;
  } catch (__error) {
    toast.error("Erro ao tentar carregar as informações do(s) boleto(s)");
    console.log("__error", __error);
  }
}

export const formatPaymentSlips = (__slips = []) => {
  let _yesterday = new Date();
  _yesterday.setDate(_yesterday.getDate() - 1);

  const _formated_slips =
    __slips?.map(__payment => {
      const _due_date = stringToDate(__payment?.due_date);
      const _due_business_date = nextBusinessDayBR(_due_date);

      let _calculated_juros = 0;
      if (
        _yesterday > _due_business_date &&
        !__payment?.juros_real_time &&
        !__payment?.value_paid &&
        __payment?.status !== "cancelado"
      ) {
        _calculated_juros = calculateFees({
          value: __payment?.value,
          due_date: __payment?.due_date,
        });
      }

      const _status =
        __payment?.status === "cancelado"
          ? "Cancelado"
          : __payment?.status === "pago"
            ? "Pago"
            : !!__payment?.status_error
              ? "Erro"
              : __payment?.status === "nao-gerado"
                ? "Em Processamento"
                : _yesterday > _due_business_date
                  ? "Atrasado"
                  : "A Vencer";

      const _method =
        __payment?.method_payment === "boleto"
          ? "Boleto"
          : __payment?.method_payment === "cartao"
            ? "Cartão"
            : __payment?.method_payment === "pix"
              ? "PIX"
              : __payment?.method_payment === "especie" || __payment?.method_payment === "dinheiro"
                ? "Espécie"
                : "Outro";

      const _payment_for =
        __payment?.customPayments?.payer_type === "produto"
          ? "Produto"
          : __payment?.customPayments?.payer_type === "formando"
            ? "Cobrança"
            : !__payment?.custom_payment_id
              ? "Contratado"
              : "Erro";

      return {
        id: __payment?.id,
        aporte: __payment?.aporte,
        bar_code: __payment?.bar_code,
        boleto_url: __payment?.boleto_url,
        document_number: __payment?.document_number,
        cancel_date: __payment?.cancel_date ? stringToDate(__payment?.cancel_date) : null,
        commercial: __payment?.commercial,
        cost_center: __payment?.costCenter,
        expense: __payment?.expense,
        expense_plan: __payment?.expensePlan,
        custom_payment_id: __payment?.custom_payment_id,
        custom_payment: __payment?.customPayments,
        date_transpasse: __payment?.date_transpasse,
        description: __payment?.description,
        due_date: _due_date,
        due_business_date: _due_business_date,
        emission: stringToDate(__payment?.emission),
        entry: __payment?.entry,
        label: __payment?.label,
        legacy_id: __payment?.legacy_id || __payment?.reboleto,
        is_legacy_reboleto: !!__payment?.reboleto,
        logs: __payment?.logBoletos,
        payment_method: __payment?.method_payment,
        payment_date: __payment?.payment_date,
        reboleto_parent_id: __payment?.payment_slip_id,
        is_reboleto: __payment?.reboleto,
        provider_id: __payment?.provider_id,
        user_id: __payment?.user_id,
        quota: __payment?.quotas,
        quotas_total: __payment?.total_quotas,
        status: _status,
        method: _method,
        tax: __payment?.tax,
        tax_description: __payment?.tax_description,
        discount_type: __payment?.type_discount,
        discount: __payment?.value_discount,
        discount_description: __payment?.discount_description,
        trainee: __payment?.trainee,
        payment_type: __payment?.type_payment,
        value_raw: __payment?.value_raw,
        value: __payment?.value,
        value_juros:
          __payment?.status === "cancelado" || __payment?.status === "pago"
            ? __payment?.juros_real_time
            : __payment?.juros_real_time || _calculated_juros || 0,
        value_paid: __payment?.value_paid,
        payment_for: _payment_for,
      };
    }) || [];
  return _formated_slips;
};
